import { JSX, ReactNode, SVGProps } from 'react';

export type ContentKeys =
/*Video */ 
"video/mp4" 
|"video/webm" 
| "video/quicktime" 
| "video/x-msvideo" 

/*Image*/ 
|"image/png" 
| "image/jpeg" 
| "image/gif" 
| "image/svg+xml" 
| "image/bmp" 
| "image/x-icon" 
| "image/tiff"
/*Documents*/
|"application/pdf"
| "text/plain"
| "text/csv"
| "application/json"
| "application/xml"
| "text/html"
| "text/markdown"
/*Office*/
| "application/msword"
| "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
| "application/vnd.ms-excel"
| "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
| "application/vnd.ms-powerpoint"
| "application/vnd.openxmlformats-officedocument.presentationml.presentation"
/*Archives*/
| "application/zip"
| "application/vnd.rar"
| "application/x-7z-compressed"
| "application/x-tar"
| "application/gzip"
/*Audio*/
| "audio/mpeg"
| "audio/wav"
| "audio/ogg"
| "audio/mp4"
| "audio/flac"


type ContentTypeIconMap = Record<ContentKeys, JSX.Element>;
export const contentTypeIconMap: ContentTypeIconMap = {
  // Video
  "video/mp4":
     <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon"
     viewBox="0 0 1024 1024"
    width={100}
    height={100}
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#8CAAFF"
        d="M759.3 352h84.3c15.5 0 28.1 9.2 28.1 20.5v277.3c0 11.3-12.6 20.5-28.1 20.5h-70.3"
      ></path>
      <path
        fill="#333"
        d="M843.5 695h-70.2v-49.5h70.2c1.4 0 2.5-.2 3.3-.4v-268c-.9-.2-2-.4-3.3-.4h-84.2v-49.5h84.3c29.6 0 52.8 19.9 52.8 45.3v277.3c0 25.4-23.3 45.2-52.9 45.2"
      ></path>
      <path
        fill="#FFF"
        d="M203.5 258h531c13.7 0 24.7 11.1 24.7 24.7v457.8c0 13.7-11.1 24.7-24.7 24.7h-531c-13.7 0-24.7-11.1-24.7-24.7V282.7c-.1-13.6 11-24.7 24.7-24.7"
      ></path>
      <path
        fill="#333"
        d="M734.5 790h-531c-27.3 0-49.5-22.2-49.5-49.5V282.7c0-27.3 22.2-49.5 49.5-49.5h531c27.3 0 49.5 22.2 49.5 49.5v457.8c0 27.3-22.2 49.5-49.5 49.5m-531-507.3v457.8h531V282.7z"
      ></path>
      <path
        fill="#8CAAFF"
        d="M595.8 521.2 407 656c-5.6 4-13.3 2.7-17.3-2.9-1.5-2.1-2.3-4.6-2.3-7.2V376.3c0-6.8 5.5-12.4 12.4-12.4 2.6 0 5.1.8 7.2 2.3L595.8 501c5.6 4 6.9 11.7 2.9 17.3-.8 1.1-1.8 2.1-2.9 2.9"
      ></path>
      <path
        fill="#333"
        d="M399.9 683c-2.1 0-4.1-.2-6.2-.5-9.8-1.6-18.4-7-24.1-15.1-4.5-6.3-6.9-13.8-6.9-21.6V376.3c0-20.5 16.6-37.1 37.1-37.1 7.8 0 15.2 2.4 21.6 6.9l188.8 134.8c8.1 5.8 13.4 14.3 15 24.1s-.6 19.6-6.4 27.7q-3.6 5.1-8.7 8.7L421.3 676.2c-6.3 4.5-13.8 6.8-21.4 6.8m12.2-282.6v221.5l155.1-110.7zM581.4 501s0 .1 0 0"
      ></path>
    </g>
  </svg>,
  "video/webm": <span>🎬</span>,
  "video/quicktime": <span>🎬</span>,
  "video/x-msvideo": <span>🎬</span>,

  // Image
  "image/png": <span>🖼️</span>,
  "image/jpeg": <span>🖼️</span>,
  "image/gif": <span>🖼️</span>,
  "image/svg+xml": <span>🖼️</span>,
  "image/bmp": <span>🖼️</span>,
  "image/x-icon": <span>🖼️</span>,
  "image/tiff": <span>🖼️</span>,

  // Documents
  "application/pdf": <span>📕</span>,
  "text/plain": <span>📄</span>,
  "text/csv": <span>📄</span>,
  "application/json": <span>🧾</span>,
  "application/xml": <span>🧾</span>,
  "text/html": <span>🌐</span>,
  "text/markdown": <span>📝</span>,

  // Office
  "application/msword": <span>📘</span>,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": <span>📘</span>,
  "application/vnd.ms-excel": <span>📊</span>,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": <span>📊</span>,
  "application/vnd.ms-powerpoint": <span>📽️</span>,
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": <span>📽️</span>,

  // Archives
  "application/zip": <span>🗜️</span>,
  "application/vnd.rar": <span>🗜️</span>,
  "application/x-7z-compressed": <span>🗜️</span>,
  "application/x-tar": <span>🗜️</span>,
  "application/gzip": <span>🗜️</span>,

  // Audio
  "audio/mpeg": <span>🎵</span>,
  "audio/wav": <span>🎵</span>,
  "audio/ogg": <span>🎵</span>,
  "audio/mp4": <span>🎵</span>,
  "audio/flac": <span>🎵</span>,
};
type FolderIconProps = SVGProps<SVGSVGElement> & {
  children?: ReactNode;
  label?:string;
  childClassName?:string
};
export const FolderIcon = ({ children,label,childClassName, ...props }: FolderIconProps) =>{
   return (
    <div
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
        width: 64,
      }}
    >
   <div className='folder-icon'>  
   <svg className='folder-svg' {...props} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -3.5 32 32">
    <g id="SVGRepo_iconCarrier">
      <path
        fill="url(#paint0_linear_103_1791)"
        fillRule="evenodd"
        d="M2.91 0h8.373c1.158 0 2.268.46 3.086 1.278l.353.353a4.36 4.36 0 0 0 3.085 1.278h5.466q1.205 0 2.057.852t.852 2.057v16q0 1.206-.852 2.057a2.8 2.8 0 0 1-2.057.852H2.909a2.8 2.8 0 0 1-2.057-.852A2.8 2.8 0 0 1 0 21.818V2.91Q0 1.704.852.852A2.8 2.8 0 0 1 2.91 0"
        clipRule="evenodd"
      ></path>
      <path
        fill="url(#paint1_linear_103_1791)"
        fillRule="evenodd"
        d="M5.818 21.818V8.728q0-1.206.852-2.058a2.8 2.8 0 0 1 2.057-.852h20.364q1.205 0 2.057.852T32 8.727v13.091q0 1.205-.852 2.057a2.8 2.8 0 0 1-2.057.852H2.909q1.205 0 2.057-.852a2.8 2.8 0 0 0 .852-2.057"
        clipRule="evenodd"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_103_1791"
          x1="16"
          x2="16"
          y1="0"
          y2="16.354"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBA200"></stop>
          <stop offset="1" stopColor="#FF7300"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_103_1791"
          x1="17.454"
          x2="17.454"
          y1="5.818"
          y2="24.727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAC227"></stop>
          <stop offset="1" stopColor="#FAA627"></stop>
        </linearGradient>
      </defs>
    </g>
  </svg>
  {children && 
    <div  className={`folder-badge ${childClassName}`}>
      {children}
  </div>
  }
  
  </div>
  {label && 
     <span
          style={{
            fontSize: 12,
            lineHeight: "14px",
            textAlign: "center",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          title={label}
        >
          {label}
        </span>
  }
  </div>
);
}
export const OfficeIcon = () => {
    return(
      <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0.497 -67.319 198.998 198.998"
  >
    <path
      id="SVGRepo_iconCarrier"
      fill="#eb3c00"
      d="M.496 51.61V13.094L34.568.502l18.517 5.924v51.85l-18.517 5.582zl34.072 4.1V10.873l-22.221 5.185v30.369zm88.877.27q-8.044 0-12.885-5.304-4.841-5.3-4.84-13.796 0-9.126 4.932-14.56 4.933-5.433 13.425-5.433 7.834 0 12.622 5.275t4.788 13.796q-.001 9.257-4.907 14.64-4.904 5.382-13.135 5.381zm.316-35.083q-5.96 0-9.68 4.3t-3.72 11.289c0 6.989 1.21 8.41 3.627 11.25s5.57 4.26 9.456 4.26q6.225 0 9.812-4.062t3.588-11.368q0-7.492-3.483-11.58-3.48-4.089-9.6-4.09zm33.488-6.122c-2.445 0-4.476.833-6.11 2.477q-2.453 2.465-2.454 6.712v4.376h-4.606v3.703h4.606V51.25h4.306V27.943h10.53V51.25h4.306V27.943h6.32V24.24h-6.32v-4.167c0-3.815 1.513-5.716 4.537-5.716 1.073 0 2.027.22 2.87.694v-3.888c-.773-.316-1.806-.487-3.124-.487-2.445 0-4.499.834-6.134 2.477q-2.454 2.467-2.454 6.712v4.376h-10.531v-4.166c0-3.816 1.51-5.717 4.536-5.717 1.072 0 2.026.22 2.87.694v-3.888c-.774-.319-1.829-.489-3.148-.489m23.188 6.7a2.74 2.74 0 0 1-1.979-.792q-.818-.791-.818-2.004c0-1.213.273-1.481.818-2.017a2.72 2.72 0 0 1 1.979-.805q1.186-.001 2.018.805.831.804.83 2.017a2.67 2.67 0 0 1-.83 1.979 2.78 2.78 0 0 1-2.018.817m2.11 33.867h-4.326v-27.01h4.325zm24.576-1.239q-3.113 1.872-7.385 1.873-5.777 0-9.323-3.76c-3.546-3.76-3.55-5.753-3.55-9.746q0-6.674 3.825-10.722 3.826-4.05 10.209-4.049 3.56 0 6.277 1.32v4.43q-3.007-2.11-6.435-2.11-4.143 0-6.794 2.968t-2.65 7.794q0 4.749 2.491 7.492 2.493 2.742 6.688 2.742 3.534 0 6.647-2.347zm26.443-11.183h-19.07q.105 4.509 2.425 6.963 2.323 2.451 6.385 2.452 4.564 0 8.387-3.007v4.062q-3.56 2.585-9.416 2.585-5.725 0-8.994-3.68-3.271-3.68-3.271-10.353 0-6.305 3.573-10.275 3.575-3.97 8.876-3.969c5.301.001 6.269 1.143 8.203 3.429q2.9 3.429 2.9 9.522v2.27zm-4.43-3.667q-.026-3.745-1.808-5.829-1.781-2.084-4.945-2.084-3.06 0-5.197 2.19t-2.636 5.723z"
    ></path>
  </svg>
    );
}
export const PdfIcon = () => {
  return(
     <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-4 0 40 40">
    <path
      id="SVGRepo_iconCarrier"
      fill="#eb3c00"
      d="M25.669 26.096c-.488.144-1.203.16-1.97.049a9.4 9.4 0 0 1-2.49-.742c1.473-.214 2.615-.148 3.592.198.23.082.611.301.868.495m-8.214-1.35-.177.048c-.396.108-.782.213-1.153.306l-.501.127c-1.008.255-2.038.516-3.055.826.387-.932.746-1.875 1.098-2.797.26-.682.526-1.379.801-2.067q.21.345.437.692a13.5 13.5 0 0 0 2.55 2.865m-2.562-10.513c.065 1.15-.183 2.257-.547 3.318-.449-1.312-.658-2.762-.097-3.932.144-.3.261-.46.338-.545.118.183.273.59.306 1.159m-5.26 14.572q-.378.675-.772 1.272c-.637.958-1.677 1.985-2.212 1.985-.052 0-.116-.008-.209-.107-.06-.062-.07-.107-.066-.169.018-.352.485-.98 1.161-1.562a11.4 11.4 0 0 1 2.098-1.419m17.738-2.659c-.082-1.174-2.059-1.927-2.078-1.934-.764-.271-1.594-.403-2.538-.403-1.01 0-2.098.146-3.497.473a12.2 12.2 0 0 1-3.122-3.209c-.354-.54-.673-1.079-.951-1.605.678-1.623 1.29-3.367 1.178-5.32-.09-1.566-.796-2.618-1.756-2.618-.659 0-1.226.488-1.688 1.451-.822 1.718-.606 3.915.643 6.537a92 92 0 0 0-1.272 3.213c-.504 1.319-1.023 2.68-1.607 3.973-1.64.65-2.987 1.436-4.109 2.402-.735.631-1.622 1.597-1.672 2.605-.025.474.138.91.468 1.258.352.37.793.566 1.279.566 1.603 0 3.146-2.202 3.439-2.644.589-.888 1.14-1.879 1.68-3.021 1.361-.492 2.811-.859 4.217-1.214l.503-.128a68 68 0 0 0 1.175-.313c.427-.115.867-.235 1.313-.349 1.443.918 2.995 1.517 4.51 1.737 1.274.185 2.406.078 3.173-.322.69-.36.728-.913.712-1.135m3.105 10.097c0 2.15-1.896 2.283-2.278 2.287H3.745c-2.143 0-2.272-1.908-2.276-2.287V3.756c0-2.152 1.899-2.283 2.276-2.287h16.518l.009.009v6.446c0 1.294.782 3.743 3.744 3.743h6.404l.055.055zm-1.519-26.045h-4.94c-2.142 0-2.272-1.898-2.275-2.274v-4.97zm2.988 26.045V11.116L21.742.87V.823h-.048L20.874 0H3.744C2.45 0 0 .785 0 3.757v32.487C0 37.543.783 40 3.745 40H28.2c1.295 0 3.745-.786 3.745-3.757"
    ></path>
  </svg>
  );
}
export const ImageFolderIcon = () => {
  return(
     <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <defs>
        <style>
          {
            ".cls-1{fill:#5f7cf9;}.cls-2{fill:#8c9eff;}.cls-3{fill:#4062ed;}.cls-4{fill:#2f58dd;}"
          }
        </style>
      </defs>
      <title />
      <g id="Image">
        <rect
          className="cls-1"
          height={20}
          rx={1}
          ry={1}
          width={28}
          x={2}
          y={6}
        />
        <path
          className="cls-2"
          d="M30,16.58V25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-.5l12.4-9.3a1,1,0,0,1,1.2,0l3.31,2.48,5.38-5.39a1,1,0,0,1,1.42,0Z"
        />
        <path
          className="cls-3"
          d="M19,13a1,1,0,0,1-.38-.08,1.15,1.15,0,0,1-.33-.21,1,1,0,0,1-.21-1.09.9.9,0,0,1,.54-.54.93.93,0,0,1,.57-.06.6.6,0,0,1,.19.06.76.76,0,0,1,.18.09l.15.12a1.15,1.15,0,0,1,.21.33,1,1,0,0,1-.21,1.09,1.15,1.15,0,0,1-.33.21A1,1,0,0,1,19,13Z"
        />
        <path
          className="cls-3"
          d="M29,6H19V26H29a1,1,0,0,0,1-1V7A1,1,0,0,0,29,6Z"
        />
        <path
          className="cls-4"
          d="M19.71,11.29l-.15-.12a.76.76,0,0,0-.18-.09.6.6,0,0,0-.19-.06H19v2a1,1,0,0,0,.38-.08,1.15,1.15,0,0,0,.33-.21,1,1,0,0,0,.21-1.09A1.15,1.15,0,0,0,19.71,11.29Z"
        />
        <path
          className="cls-1"
          d="M24.29,12.29,19,17.59V26H29a1,1,0,0,0,1-1V16.58l-4.29-4.29A1,1,0,0,0,24.29,12.29Z"
        />
      </g>
    </g>
  </svg>
  );
} 
export const VideoFolderIcon = () => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g id="SVGRepo_iconCarrier">
      <path
        fill="#e75749"
        d="M4.5 2.375A2.56 2.56 0 0 1 5.861 2h20.366a2.545 2.545 0 0 1 2.423 1.951 3.4 3.4 0 0 1 .072.862v11.176h-1.573a2 2 0 0 0-.22.022 5 5 0 0 0-.581-.011c-.3.007-.61-.014-.914.014a2.3 2.3 0 0 0-.4-.02h-4.739c-.2 0-.392.008-.587-.01l.1-.065-6.353-3.813v3.889c-2.213-.005-4.427 0-6.64 0a2 2 0 0 0-.251.021c-.212-.032-.427-.016-.642-.016-.284.006-.57-.015-.853.015a2 2 0 0 0-.253-.022H3.275c.006-3.635 0-7.27 0-10.9a4.8 4.8 0 0 1 .071-1.131A2.54 2.54 0 0 1 4.5 2.375m.54 2.188a.64.64 0 0 0-.489.606v1.316a.64.64 0 0 0 .627.6h1.309a.64.64 0 0 0 .6-.608c.005-.426 0-.853 0-1.279a.64.64 0 0 0-.329-.575.7.7 0 0 0-.358-.078H5.264a1 1 0 0 0-.224.018m20.341 0a.64.64 0 0 0-.474.607v1.306a.64.64 0 0 0 .6.608c.436.005.872 0 1.308 0a.64.64 0 0 0 .627-.606c.006-.438 0-.876 0-1.314a.64.64 0 0 0-.594-.621c-.348-.009-.7 0-1.045 0a2 2 0 0 0-.422.024ZM5.042 8.38a.64.64 0 0 0-.452.4 1.1 1.1 0 0 0-.041.386v1.135a.637.637 0 0 0 .6.6c.4.008.795 0 1.192 0a.8.8 0 0 0 .395-.065.64.64 0 0 0 .36-.574V8.983a.64.64 0 0 0-.6-.624c-.338-.008-.677 0-1.016 0a2.4 2.4 0 0 0-.438.021m20.338 0a.64.64 0 0 0-.433.4 1.1 1.1 0 0 0-.041.387v1.131a.64.64 0 0 0 .608.607c.406.006.812 0 1.218 0a.74.74 0 0 0 .38-.078.64.64 0 0 0 .335-.558V8.985a.637.637 0 0 0-.593-.622c-.349-.009-.7 0-1.047 0a2 2 0 0 0-.428.022ZM5.041 12.2a.64.64 0 0 0-.491.608c0 .438-.005.877 0 1.315a.64.64 0 0 0 .627.6h1.3a.64.64 0 0 0 .608-.607v-1.307a.64.64 0 0 0-.605-.626c-.348-.007-.7 0-1.045 0a2 2 0 0 0-.394.017m20.335.006a.64.64 0 0 0-.43.394 1.1 1.1 0 0 0-.041.386v1.131a.64.64 0 0 0 .607.608c.435.005.87 0 1.306 0a.64.64 0 0 0 .628-.605c.006-.438 0-.876 0-1.313a.637.637 0 0 0-.592-.622c-.349-.01-.7 0-1.046 0a2 2 0 0 0-.431.015Z"
      ></path>
      <path
        fill="#fff"
        d="M13.458 12.1q3.176 1.908 6.353 3.813l-.1.065q-3.127 1.872-6.251 3.748V15.99q-.003-1.941-.002-3.89"
      ></path>
      <path
        fill="#c0392b"
        d="M3.275 15.988h1.541a2 2 0 0 1 .253.022.65.65 0 0 0-.409.273.9.9 0 0 0-.111.518v1.045a.686.686 0 0 0 .685.689h1.192a.68.68 0 0 0 .657-.569c.008-.447 0-.9 0-1.343a.63.63 0 0 0-.521-.613 2 2 0 0 1 .251-.021h6.64v3.736q3.127-1.871 6.251-3.748c.2.018.391.007.587.01h4.741a2.3 2.3 0 0 1 .4.02.64.64 0 0 0-.475.385 1 1 0 0 0-.045.407v1.014a.677.677 0 0 0 .691.719h1.16a.684.684 0 0 0 .686-.658v-.984a1.07 1.07 0 0 0-.1-.589.64.64 0 0 0-.42-.292 2 2 0 0 1 .22-.022h1.573c.011 1.721 0 3.443 0 5.165v6.293a2.57 2.57 0 0 1-.612 1.651 2.54 2.54 0 0 1-1.563.868 8 8 0 0 1-.981.033H6.724a9 9 0 0 1-1.368-.048 2.56 2.56 0 0 1-2-1.846 2.8 2.8 0 0 1-.09-.746V16.891c.007-.3-.002-.602.009-.903m1.795 3.843a.61.61 0 0 0-.386.234.76.76 0 0 0-.134.464v1.162a.685.685 0 0 0 .686.658h1.283a.687.687 0 0 0 .568-.716v-1.191a.62.62 0 0 0-.2-.458.7.7 0 0 0-.487-.17H5.264a1 1 0 0 0-.194.017m20.366 0a.62.62 0 0 0-.522.58v1.222a.676.676 0 0 0 .69.718c.428 0 .857.005 1.285 0a.7.7 0 0 0 .562-.684v-1.013a.9.9 0 0 0-.123-.568.66.66 0 0 0-.532-.267h-.954a2.3 2.3 0 0 0-.406.011ZM5.071 23.648a.6.6 0 0 0-.4.249.77.77 0 0 0-.124.448v1.132a.7.7 0 0 0 .6.688h1.376a.687.687 0 0 0 .567-.717v-1.189a.62.62 0 0 0-.2-.459.7.7 0 0 0-.484-.17H5.265a1 1 0 0 0-.194.018m20.362 0a.62.62 0 0 0-.492.427 1 1 0 0 0-.029.33V25.6a.68.68 0 0 0 .656.567h1.193a.69.69 0 0 0 .686-.719v-1.164a.66.66 0 0 0-.286-.545 1.46 1.46 0 0 0-.787-.11c-.312.01-.629-.02-.94.018Z"
      ></path>
    </g>
  </svg>
  )
}
